import { Component, OnInit, Input, TemplateRef, inject } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {NgbOffcanvas} from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from "@ngx-translate/core";
import { LanguageService } from "../lang/language.service";
import { SiteMassageModel } from "src/app/core/models/site-massage.model";
import { SiteMassageService } from "src/app/core/services/site-massage.service";
import { ToastrService } from "ngx-toastr";


@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
})

/***
 * Header Component
 */
export class HeaderComponent implements OnInit {

  @Input() navClass: string = '';
  @Input() buttonList: boolean = false;
  @Input() sliderTopbar: boolean = false;
  @Input() isdeveloper: boolean = false;
  @Input() shopPages: boolean = false;
  @Input() Settingicon: boolean = false;
  @Input() appicons: boolean = false;
  @Input() Nfticons: boolean = false;
  @Input() Menuoption: string = '';

  public href: string = "";




  constructor(private router: Router, private modalService: NgbModal,
     private offcanvasService: NgbOffcanvas,
      public langService: LanguageService ,private MassageService:SiteMassageService,private toastr: ToastrService,private translate : TranslateService) {
    this.router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        this._activateMenuDropdown();
      }
    });
  }
 switchLanguage(lang: 'ar' | 'en') {
  if (lang === 'ar' && this.isDark) {
    this.darkRtl();
  } else if (lang === 'ar' && !this.isDark) {
    this.setRtl();     
  } else if (lang === 'en' && this.isDark) {
    this.darkLtr();
  } else if (lang === 'en' && !this.isDark) {
    this.setLtr();      
  }

  this.langService.setLanguage(lang);
  const currentPath = window.location.pathname;
  const newPath = currentPath.replace(/^\/[a-z]{2}\//, `/${lang}/`);
  window.location.href = newPath;
}
  isCondensed = false;

  ngAfterViewInit() {
    setTimeout(() => {
      this._activateMenuDropdown();
          }, 0);
  }

  ngOnInit(): void {
    this.href = this.router.url;
    this.applySavedTheme();
    if (this.router.url == '/index-classic-saas') {
      var light_btn = document.querySelectorAll(".login-btn-primary")
      light_btn.forEach(element => {
        (element as HTMLElement).style.display = "none";
      });

      var dark_btn = document.querySelectorAll(".login-btn-light")
      dark_btn.forEach(element => {
        (element as HTMLElement).style.display = "block";
      });
    }
    else if (this.router.url == '/index-apps') {
      document.querySelector('.app-header').classList.remove('d-none');
    }
    else {
      var light_btn = document.querySelectorAll(".login-btn-primary")
      light_btn.forEach(element => {
        (element as HTMLElement).style.display = "block";
      });

      var dark_btn = document.querySelectorAll(".login-btn-light")
      dark_btn.forEach(element => {
        (element as HTMLElement).style.display = "none";
      });
      
    }

    setTimeout(() => {
      this._activateMenuDropdown();
          }, 0);
  }

  _activateMenuDropdown() {
    /**
     * Menu activation reset
     */
    const resetParent = (el) => {
      el.classList.remove("active");
      const parent = el.parentElement;

      /**
       * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
       * We should come up with non hard coded approach
       */
      if (parent) {
        parent.classList.remove("active");
        const parent2 = parent.parentElement;
        if (parent2) {
          parent2.classList.remove("active");
          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("active");
            const parent4 = parent3.parentElement;
            if (parent4) {
              const parent5 = parent4.parentElement;
              parent5.classList.remove("active");

            }
          }
        }
      }
    };
    let links = document.getElementsByClassName("nav-link-ref");
    let matchingMenuItem = null;
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < links.length; i++) {
      // reset menu
      resetParent(links[i]);
    }
    for (let i = 0; i < links.length; i++) {
      if (window.location.pathname === links[i]["pathname"]) {
        matchingMenuItem = links[i];
        break;
      }
    }

    if (matchingMenuItem) {
      matchingMenuItem.classList.add("active");
      const parent = matchingMenuItem.parentElement;

      /**
       * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
       * We should come up with non hard coded approach
       */
      if (parent) {
        parent.classList.add("active");
        const parent2 = parent.parentElement;
        if (parent2) {
          parent2.classList.add("active");
          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.add("active");
            const parent4 = parent3.parentElement;
            if (parent4) {
              const parent5 = parent4.parentElement;
              parent5.classList.add("active");

              document.getElementById("navigation").style.display = "none";
              this.isCondensed = false;
            }
          }
        }
      }
    }
  }

  /**
   * Window scroll method
   */
  // tslint:disable-next-line: typedef
  windowScroll() {
    if (
      document.body.scrollTop > 50 ||
      document.documentElement.scrollTop > 50
    ) {
      document.getElementById("topnav").classList.add("nav-sticky");

    } else {
      document.getElementById("topnav").classList.remove("nav-sticky");
      }
    if (document.getElementById("back-to-top")) {
      if (
        document.body.scrollTop > 100 ||
        document.documentElement.scrollTop > 100
      ) {
        document.getElementById("back-to-top").style.display = "inline";
      } else {
        document.getElementById("back-to-top").style.display = "none";
      }
    }
  }
  /**
   * Toggle menu
   */
  toggleMenu() {
    this.isCondensed = !this.isCondensed;
    if (this.isCondensed) {
      document.getElementById("navigation").style.display = "block";
    } else {
      document.getElementById("navigation").style.display = "none";
    }
  }

  /**
   * Menu clicked show the submenu
   */
  onMenuClick(event) {
    event.preventDefault();
    const nextEl = event.target.nextSibling.nextSibling;
    if (nextEl && !nextEl.classList.contains("open")) {
      const parentEl = event.target.parentNode;
      if (parentEl) {
        parentEl.classList.remove("open");
      }
      nextEl.classList.add("open");
    } else if (nextEl) {
      nextEl.classList.remove("open");
    }
    return false;
  }

  developerModal(content) {
    this.modalService.open(content, { size: 'lg', centered: true });
  }

  wishListModal(content) {
    this.modalService.open(content, { centered: true });
  }

  // Demo Offcanvas
  openright(content: TemplateRef<any>) {  
    this.offcanvasService.open(content, {    panelClass: 'offcanvas-500px',position: 'end' });
  }
  isDark = false;
setDark() {
  debugger;
  this.isDark = true;
    var doc = document.getElementById('theme-opt')
    doc?.setAttribute('href', './assets/css/style-dark.min.css');
  }
   setLight() {
    this.isDark = false;
    // (document.querySelector('.t-rtl-dark') as HTMLElement).style.display = "none";
    // (document.querySelector('.t-rtl-light') as HTMLElement).style.display = "inline-block";    
    document.querySelector('.theme-opt').setAttribute('href', './assets/css/bootstrap-rtl.min.css');

  }
  darkRtl() {
    document.documentElement.dir = "rtl";
    // (document.querySelector('.t-rtl-dark') as HTMLElement).style.display = "none";
    // (document.querySelector('.t-ltr-dark') as HTMLElement).style.display = "inline-block";    
    document.querySelector('.theme-opt').setAttribute('href', './assets/css/bootstrap-dark-rtl.min.css');
    document.querySelector('.theme-opt-style').setAttribute('href', './assets/css/style-dark-rtl.min.css');
  }
  /**
   * Set dark-light theme
   */
  darkLtr() {   
    // (document.querySelector('.t-dark') as HTMLElement).style.display = "none";
    // (document.querySelector('.t-light') as HTMLElement).style.display = "inline-block";
    // (document.querySelector('.t-rtl-dark') as HTMLElement).style.display = "inline-block";
    // (document.querySelector('.t-rtl-light') as HTMLElement).style.display = "none";
    // (document.querySelector('.t-ltr-dark') as HTMLElement).style.display = "none";    
    document.querySelector('.theme-opt').setAttribute('href', './assets/css/bootstrap-dark.min.css');
    document.querySelector('.theme-opt-style').setAttribute('href', './assets/css/style-dark.min.css');
    document.documentElement.dir = "ltr";
  }

  /**
   * Set dark-light theme
   */
  lightLtr() {  
    // (document.querySelector('.t-dark') as HTMLElement).style.display = "inline-block";
    // (document.querySelector('.t-light') as HTMLElement).style.display = "none";
    // (document.querySelector('.t-rtl-dark') as HTMLElement).style.display = "none";
    // (document.querySelector('.t-rtl-light') as HTMLElement).style.display = "inline-block";
    // (document.querySelector('.t-ltr-dark') as HTMLElement).style.display = "none";  
    document.querySelector('.theme-opt').setAttribute('href', './assets/css/bootstrap.min.css');
    document.querySelector('.theme-opt-style').setAttribute('href', './assets/css/style.min.css');
    document.documentElement.dir = "ltr";
  }
  /**
   * Set rtl theme
   */
  setRtl() {
    document.documentElement.dir = "rtl";
    // (document.querySelector('.t-rtl-light') as HTMLElement).style.display = "none";
    // (document.querySelector('.t-ltr-light') as HTMLElement).style.display = "inline-block";    
    document.querySelector('.theme-opt').setAttribute('href', './assets/css/bootstrap-rtl.min.css');
    document.querySelector('.theme-opt-style').setAttribute('href', './assets/css/style-rtl.min.css');
  }
  /**
   * Set light theme
   */
  setLtr() {
    document.documentElement.dir = "ltr";
    // (document.querySelector('.t-ltr-light') as HTMLElement).style.display = "none";
    // (document.querySelector('.t-rtl-light') as HTMLElement).style.display = "inline-block";    
    document.querySelector('.theme-opt').setAttribute('href', './assets/css/bootstrap.min.css');
    document.querySelector('.theme-opt-style').setAttribute('href', './assets/css/style.min.css');
  }
changTheme() {
  const isRtl = document.documentElement.dir === 'rtl';
  this.isDark = !this.isDark;                              
  localStorage.setItem(this.THEME_KEY, this.isDark ? 'dark' : 'light'); 

  if (this.isDark && isRtl) {
    this.darkRtl();
  } else if (this.isDark && !isRtl) {
    this.darkLtr();
  } else if (!this.isDark && isRtl) {
    this.setRtl();
  } else {
    this.setLtr();
  }
}
    massage:SiteMassageModel = {};
  
  sendMessage(){
    debugger;
    this.massage.Id = 0;
    this.MassageService.insert(this.massage)
    .subscribe(result=>{
      if(result == true){
   this.toastr.success(this.translate.instant('Your Message Sent Successfully'),this.translate.instant('Success'));
     this.modalService.dismissAll();
      }
this.massage = {};
    })
  }

  private readonly THEME_KEY = 'app-theme'; // 'dark' | 'light'

private applySavedTheme(): void {
  const savedTheme = localStorage.getItem(this.THEME_KEY);
  this.isDark = savedTheme === 'dark';
  const isRtl = this.langService.getCurrentLang() === 'ar';

  if (this.isDark && isRtl) {
    this.darkRtl();
  } else if (this.isDark && !isRtl) {
    this.darkLtr();
  } else if (!this.isDark && isRtl) {
    this.setRtl();
  } else {
    this.setLtr();
  }
}
}
